import { ORIGEN_LEAD_VALUES, REGEX } from '../config'
import { getScreenResolution } from './getScreenResolution'
import { setPonderation } from './setPonderation'

export function updateTagsForDRPLeads() {
  const waitDRP = setInterval(() => {
    if (
      typeof DRP !== 'undefined' &&
      window.DRP.ringPoolCompleted &&
      typeof window.DFI !== 'undefined' &&
      typeof window.DFI.labels !== 'undefined' &&
      typeof window._satellite !== 'undefined'
    ) {
      clearInterval(waitDRP)
      const DEFAULT_DL_VALUE = 'Not value in DL'

      const getTagFromAdobe = ({ tag }) => {
        return window?._satellite?.getVar(`digitalData.page.pageinfo.${tag}`)
      }

      const setDefaultValueToProduct = () => {
        if (
          typeof getTagFromAdobe({ tag: 'producto' }) === 'undefined' ||
          getTagFromAdobe({ tag: 'producto' }).length < 2 ||
          REGEX.CHARACTERS_NOT_VISIBLE.test(
            getTagFromAdobe({ tag: 'producto' })
          )
        ) {
          return DEFAULT_DL_VALUE
        }

        return getTagFromAdobe({ tag: 'producto' })
      }

      const DATALAYER_VALUES = {
        ORIGIN: getTagFromAdobe({ tag: 'origen' }) ?? DEFAULT_DL_VALUE,
        RAMO: getTagFromAdobe({ tag: 'ramo' }) ?? DEFAULT_DL_VALUE,
        PRODUCT: setDefaultValueToProduct(),
        ID_LANDING: getTagFromAdobe({ tag: 'IDlanding' }) ?? DEFAULT_DL_VALUE
      }

      const allianzFormActions = localStorage.getItem('allianzFormActions')
      if (
        (window.location.href == 'https://www.allianz.es/t/quote-test.html' ||
          window.location.href.indexOf('https://calcularseguro.allianz.es/') >=
            0) &&
        allianzFormActions
      ) {
        const allianzFormActionsJSON = JSON.parse(allianzFormActions)
        DATALAYER_VALUES.ORIGIN = allianzFormActionsJSON.origen
        DATALAYER_VALUES.RAMO = allianzFormActionsJSON.ramo
        DATALAYER_VALUES.PRODUCT = allianzFormActionsJSON.product
        DATALAYER_VALUES.ID_LANDING = allianzFormActionsJSON.idLanding
      }

      const resolution = getScreenResolution()

      window.DFI_client.resolucion_pantalla = resolution

      if (typeof window._satellite === 'undefined') return

      window.DFI_client.ponderacion = setPonderation()

      window.DFI_client.origen = DATALAYER_VALUES.ORIGIN
      window.DFI_client.ramo = DATALAYER_VALUES.RAMO
      window.DFI_client.producto = DATALAYER_VALUES.PRODUCT
      window.DFI_client.idLanding = DATALAYER_VALUES.ID_LANDING
      window.DFI_client.userAgent = encodeURIComponent(
        window.navigator.userAgent
      )
      window.DFI_client.fbp = DFI.getCookie('_fbp')
      window.DFI_client.fbc = DFI.getCookie('_fbc')
      window.DFI_client.LeadFinSemana = 'false'
      // if (window.location.href.includes("seguro-decesos.html")){
      //     window.DFI_client.qb_test_calcular="A"
      // }

      // const today = new Date();
      // const dayOfWeek = today.getDay();

      // // 0 is Sunday, 6 is Saturday
      // if( dayOfWeek === 0 || dayOfWeek === 6){
      //   window.DFI_client.LeadFinSemana="true"
      // }

      const today = new Date()
      const dayOfWeek = today.getDay()
      const currentHour = today.getHours()

      if (
        (dayOfWeek === 5 && currentHour >= 20) ||
        dayOfWeek === 6 ||
        dayOfWeek === 0
      ) {
        window.DFI_client.LeadFinSemana = 'true'
      }

      window.DFI.labels.EDeclaratives = {
        ...window.DFI.labels.EDeclaratives,
        ramo: DATALAYER_VALUES.RAMO,
        origen: DATALAYER_VALUES.ORIGIN,
        producto: DATALAYER_VALUES.PRODUCT,
        idLanding: DATALAYER_VALUES.ID_LANDING,
        ponderacion: setPonderation(),
        resolucion_pantalla: resolution,
        origen_lead: ORIGEN_LEAD_VALUES.RINGPOOL_DESKTOP,
        userAgent: encodeURIComponent(window.navigator.userAgent),
        tipo_url: window.tipoUrlTag,
        fbp: window.DFI_client.fbp,
        fbc: window.DFI_client.fbc,
        LeadFinSemana: window.DFI_client.LeadFinSemana
        // qb_test_calcular:window.DFI_client.qb_test_calcular
      }

      const labels = {
        EDeclaratives: window.DFI.labels.EDeclaratives
      }
      window.DRP.loadLabels(labels)
    }
  }, 500)
}

// export function updateTagsForDRPLeads() {
//   const waitDRP = setInterval(() => {
//     if (
//       typeof DRP !== 'undefined' &&
//       window.DRP.ringPoolCompleted &&
//       typeof window.DFI !== 'undefined' &&
//       typeof window.DFI.labels !== 'undefined' &&
//       typeof window._satellite !== 'undefined'
//     ) {
//       clearInterval(waitDRP)
//       const DEFAULT_DL_VALUE = 'Not value in DL'

//       // Función para obtener valores de allianzFormActions desde localStorage
//       const getFromLocalStorage = (key) => {
//         const allianzFormActions = localStorage.getItem('allianzFormActions');
//         if (allianzFormActions) {
//           try {
//             const parsed = JSON.parse(allianzFormActions); // Parseamos el JSON
//             return parsed[key] ?? DEFAULT_DL_VALUE; // Si no existe la propiedad, devolvemos el valor por defecto
//           } catch (e) {
//             console.error('Error parsing allianzFormActions:', e);
//             return DEFAULT_DL_VALUE; // En caso de error de parseo
//           }
//         }
//         return DEFAULT_DL_VALUE; // Si no existe el item en localStorage
//       }

//       // Obtener 'ramo' y 'origen' de allianzFormActions en LocalStorage
//       const ramoFromLocalStorage = getFromLocalStorage('ramo');
//       const origenFromLocalStorage = getFromLocalStorage('origen');

//       // Obtenemos otros valores necesarios para el Data Layer
//       const getTagFromAdobe = ({ tag }) => {
//         return window?._satellite?.getVar(`digitalData.page.pageinfo.${tag}`)
//       }

//       const setDefaultValueToProduct = () => {
//         const producto = getTagFromAdobe({ tag: 'producto' });
//         if (
//           typeof producto === 'undefined' ||
//           producto.length < 2 ||
//           REGEX.CHARACTERS_NOT_VISIBLE.test(producto)
//         ) {
//           return DEFAULT_DL_VALUE;
//         }
//         return producto;
//       }

//       const DATALAYER_VALUES = {
//         ORIGIN: origenFromLocalStorage, // Asignamos 'origen' desde localStorage
//         RAMO: ramoFromLocalStorage,     // Asignamos 'ramo' desde localStorage
//         PRODUCT: setDefaultValueToProduct(),
//         ID_LANDING: getTagFromAdobe({ tag: 'IDlanding' }) ?? DEFAULT_DL_VALUE
//       }

//       const resolution = getScreenResolution();

//       // Asignamos la resolución a la propiedad correspondiente
//       window.DFI_client.resolucion_pantalla = resolution;

//       if (typeof window._satellite === 'undefined') return;

//       // Asignamos ponderación y otros valores de cliente
//       window.DFI_client.ponderacion = setPonderation();

//       window.DFI_client.origen = DATALAYER_VALUES.ORIGIN;
//       window.DFI_client.ramo = DATALAYER_VALUES.RAMO;
//       window.DFI_client.producto = DATALAYER_VALUES.PRODUCT;
//       window.DFI_client.idLanding = DATALAYER_VALUES.ID_LANDING;
//       window.DFI_client.userAgent = encodeURIComponent(window.navigator.userAgent);
//       window.DFI_client.fbp = DFI.getCookie("_fbp");
//       window.DFI_client.fbc = DFI.getCookie("_fbc");
//       window.DFI_client.LeadFinSemana = "false";

//       // Lógica para marcar si es fin de semana
//       const today = new Date();
//       const dayOfWeek = today.getDay();
//       const currentHour = today.getHours();

//       if ((dayOfWeek === 5 && currentHour >= 20) || dayOfWeek === 6 || dayOfWeek === 0) {
//         window.DFI_client.LeadFinSemana = "true";
//       }

//       // Actualizamos las etiquetas en DFI
//       window.DFI.labels.EDeclaratives = {
//         ...window.DFI.labels.EDeclaratives,
//         ramo: DATALAYER_VALUES.RAMO,  // Asignamos 'ramo'
//         origen: DATALAYER_VALUES.ORIGIN, // Asignamos 'origen'
//         producto: DATALAYER_VALUES.PRODUCT,
//         idLanding: DATALAYER_VALUES.ID_LANDING,
//         ponderacion: setPonderation(),
//         resolucion_pantalla: resolution,
//         origen_lead: ORIGEN_LEAD_VALUES.RINGPOOL_DESKTOP,
//         userAgent: encodeURIComponent(window.navigator.userAgent),
//         tipo_url: window.tipoUrlTag,
//         fbp: window.DFI_client.fbp,
//         fbc: window.DFI_client.fbc,
//         LeadFinSemana: window.DFI_client.LeadFinSemana
//       }

//       // Cargamos las etiquetas actualizadas en DRP
//       const labels = {
//         EDeclaratives: window.DFI.labels.EDeclaratives
//       }
//       window.DRP.loadLabels(labels);
//     }
//   }, 500);
// }
